var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSolitacoesModal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2062",
    "data-name": "Grupo 2062",
    transform: "translate(-7 -22)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2068",
    "data-name": "Grupo 2068"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2069",
    "data-name": "Grupo 2069"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2005",
    "data-name": "Grupo 2005",
    transform: "translate(-718 -665)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_40",
    "data-name": "Elipse 40",
    cx: 27,
    cy: 27,
    r: 27,
    transform: "translate(725 687)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2019",
    "data-name": "Grupo 2019",
    transform: "translate(19 34)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1193",
    "data-name": "Caminho 1193",
    d: "M179.3,264.651a1.452,1.452,0,1,1-1.452-1.452,1.452,1.452,0,0,1,1.452,1.452",
    transform: "translate(-176.398 -249.651)",
    fill: "#010066"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1194",
    "data-name": "Caminho 1194",
    d: "M200.954,185.01a1.452,1.452,0,1,1-1.983.531,1.452,1.452,0,0,1,1.983-.531",
    transform: "translate(-196.843 -178.04)",
    fill: "#010066"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1195",
    "data-name": "Caminho 1195",
    d: "M257.487,129.5a1.452,1.452,0,1,1-1.983-.531,1.452,1.452,0,0,1,1.983.531",
    transform: "translate(-248.006 -126.845)",
    fill: "#010066"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1196",
    "data-name": "Caminho 1196",
    d: "M256.954,397.812a1.452,1.452,0,1,1-1.983.531,1.451,1.451,0,0,1,1.983-.531",
    transform: "translate(-248.005 -372.455)",
    fill: "#010066"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1197",
    "data-name": "Caminho 1197",
    d: "M201.489,342.3a1.452,1.452,0,1,1-1.983-.531,1.451,1.451,0,0,1,1.983.531",
    transform: "translate(-196.846 -321.257)",
    fill: "#010066"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1198",
    "data-name": "Caminho 1198",
    d: "M350,106.4v2.9a12.1,12.1,0,0,1,0,24.193v2.9a15,15,0,0,0,0-30Z",
    transform: "translate(-335 -106.4)",
    fill: "#010066"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1199",
    "data-name": "Caminho 1199",
    d: "M277.43,223.33l-6.716,6.716-3.329-3.329-2.051,2.051,4.355,4.355h0a1.452,1.452,0,0,0,2.052,0l7.742-7.742Z",
    transform: "translate(-257.65 -213.227)",
    fill: "#010066"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSolitacoesModal);
export default __webpack_public_path__ + "static/media/icon_solitacoesModal.d2f700dfb9aa018e4d12222f81239679.svg";
export { ForwardRef as ReactComponent };